define('wax-resist',["wax-resist-common"], function(resist) {

  if (window.matchMedia && window.matchMedia("(max-device-width: 768px)").matches) {
    //don't run on mobile
    return;
  }

  var quotes = Array.prototype.slice.call(document.querySelectorAll("[resist]"));

  quotes.forEach(function(quote) {

    var canvas = document.createElement("canvas");
    canvas.className = "quote-resist";
    quote.appendChild(canvas);

    var context = canvas.getContext("2d");
    resist.init(context);

    resist.bindMouse(quote, context, canvas.width / 5);

    var url = quote.getAttribute("resist") || "../assets/texture-3.jpg";
    resist.loadPattern(context, url, function() {

      //trigger scroll effects only once the texture is loaded
      var onScroll = function() {
        var bounds = quote.getBoundingClientRect();
        if (bounds.top > 0 && bounds.bottom < window.innerHeight) {
          //trigger animation on scroll
          var r = canvas.width / 5;
          var swipe = {
            start: {
              x: 0,
              y: Math.random() * .3
            },
            end: {
              x: 1,
              y: Math.random() * .3
            },
            duration: 200
          };
          resist.animate(context, swipe, function(x, y) {
            resist.revealPoly(context, x, y, (Math.random() * .2 + .8) * r);
            resist.speckle(context, x, y, r);
          });
          document.removeEventListener("scroll", onScroll);
        }
      };

      document.addEventListener("scroll", onScroll);
      onScroll();

    });

  });

});
